var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { staticClass: "px-0", attrs: { fluid: "" } },
    [
      !!_vm.revisionEvaluador
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-overlay",
                    { attrs: { show: _vm.mostrarOverlay } },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("strong", [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.valoracionPlenariaSNP.campos.solucion"
                                    ) + ":"
                                  ),
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("b-col", [
                            _c("strong", [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.valoracionPlenariaSNP.campos.comisionEvaluacion"
                                    ) + ":"
                                  ),
                                },
                              }),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.revisionEvaluador?.solicitudResumen
                                    ?.nombre ?? ""
                                ),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("b-col", [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.revisionEvaluador?.respuesta?.comision ??
                                    ""
                                ),
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mt-2" },
                        [
                          _c("b-col", [
                            _c("strong", [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.valoracionPlenariaSNP.campos.estado"
                                    ) + ":"
                                  ),
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("b-col", [
                            _c("strong", [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.valoracionPlenariaSNP.campos.tipoEvaluacion"
                                    ) + ":"
                                  ),
                                },
                              }),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.revisionEvaluador?.estado ?? ""
                                ),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("b-col", [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.evaluacionPlenariaDescripcion ?? ""
                                ),
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("hr", { staticClass: "linea-horizontal-roja" }),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c("cuestionario-snp", {
                                attrs: {
                                  preguntas: _vm.preguntas,
                                  esMoloLectura:
                                    _vm.estadoInsaculacion != "APROBADA" &&
                                    _vm.revisionEvaluador.estado != "ASIGNADA",
                                  cuestionarioInicial: _vm.cuestionarioInicial,
                                  revisionesIndividuales:
                                    _vm.revisionesIndividuales,
                                  mostrarRecomendacion: true,
                                },
                                on: { change: _vm.manejaFormularioCambia },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mt-3" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "text-right" },
                            [
                              _vm.estadoInsaculacion == "APROBADA" &&
                              _vm.revisionEvaluador.estado == "ASIGNADA"
                                ? _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          value: _vm.$t(
                                            "apeironGwApp.valoracionPlenariaSNP.acciones.guardarTooltip"
                                          ),
                                          expression:
                                            "$t('apeironGwApp.valoracionPlenariaSNP.acciones.guardarTooltip')",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass: "btn-primary",
                                      on: {
                                        click: function ($event) {
                                          return _vm.mostrarModalGuardar()
                                        },
                                      },
                                    },
                                    [
                                      _c("b-icon", {
                                        attrs: {
                                          icon: _vm.guardandoEvaluacion
                                            ? "asterisk"
                                            : "check-square",
                                          animation: _vm.guardandoEvaluacion
                                            ? "spin-pulse"
                                            : "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.valoracionPlenariaSNP.acciones.guardar"
                                            )
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.estadoInsaculacion == "APROBADA" &&
                              _vm.revisionEvaluador.estado == "ASIGNADA"
                                ? _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          value: _vm.$t(
                                            "apeironGwApp.valoracionPlenariaSNP.acciones.finalizarTooltip"
                                          ),
                                          expression:
                                            "$t('apeironGwApp.valoracionPlenariaSNP.acciones.finalizarTooltip')",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass: "btn-primary",
                                      attrs: { disabled: !_vm.puedeFinalizar },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mostrarModalFinalizar()
                                        },
                                      },
                                    },
                                    [
                                      _c("b-icon", {
                                        attrs: {
                                          icon: _vm.finalizandoEvaluacion
                                            ? "asterisk"
                                            : "clipboard-check",
                                          animation: _vm.finalizandoEvaluacion
                                            ? "spin-pulse"
                                            : "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.valoracionPlenariaSNP.acciones.finalizar"
                                            )
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("firmar-dictamen-snp", {
                                attrs: {
                                  revisionId: _vm.revisionEvaluador.id,
                                  permitirFirmar: false,
                                  urlDictamen: _vm.obtenerUrlDeDictamen,
                                  estadoInsaculacion: _vm.estadoInsaculacion,
                                  estadoRevision: _vm.revisionEvaluador.estado,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-modal",
                {
                  attrs: { id: "modal-guardar", size: "md" },
                  scopedSlots: _vm._u([
                    {
                      key: "modal-title",
                      fn: function () {
                        return [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.valoracionPlenariaSNP.modal.tituloModalGuardar"
                                )
                              ),
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "modal-footer",
                      fn: function () {
                        return [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "secondary" },
                              on: {
                                click: function ($event) {
                                  _vm.verModalGuardar = false
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.valoracionPlenariaSNP.acciones.cerrar"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.guardarEvaluacion()
                                },
                              },
                            },
                            [
                              _c("b-icon", { attrs: { icon: "save" } }),
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.valoracionPlenariaSNP.acciones.guardar"
                                    )
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.verModalGuardar,
                    callback: function ($$v) {
                      _vm.verModalGuardar = $$v
                    },
                    expression: "verModalGuardar",
                  },
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c("h5", [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.valoracionPlenariaSNP.modal.detalleModalGuardar"
                                )
                              ),
                            },
                          }),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  attrs: { id: "modal-finalizar", size: "md" },
                  scopedSlots: _vm._u([
                    {
                      key: "modal-title",
                      fn: function () {
                        return [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.valoracionPlenariaSNP.modal.tituloModalFinalizar"
                                )
                              ),
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "modal-footer",
                      fn: function () {
                        return [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "secondary" },
                              on: {
                                click: function ($event) {
                                  _vm.verModalFinalizar = false
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.valoracionPlenariaSNP.acciones.cerrar"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.finalizarEvaluacion()
                                },
                              },
                            },
                            [
                              _c("b-icon", { attrs: { icon: "save" } }),
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.valoracionPlenariaSNP.acciones.finalizar"
                                    )
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.verModalFinalizar,
                    callback: function ($$v) {
                      _vm.verModalFinalizar = $$v
                    },
                    expression: "verModalFinalizar",
                  },
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c("h5", [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.valoracionPlenariaSNP.modal.detalleModalFinalizar"
                                )
                              ),
                            },
                          }),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }